//JS操作cookies方法!

export default {
  //写cookies
  setCookie: (name, value, expiredTime) =>{
    let Days = 30;
    let exp = new Date();
    exp.setTime(exp.getTime() + Days*24*60*60*1000);
    let _expiredTime = expiredTime ? expiredTime : exp;
    document.cookie = name + "=" + encodeURIComponent(value) + ";expires=" + _expiredTime.toUTCString();
  },
  //读cookies
  getCookie: name => {
    let arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    arr = document.cookie.match(reg);
    if (arr)
      return decodeURIComponent(arr[2]);
    else
      return null;
  },
  //删除cookies
  delCookie: name => {
    let exp = new Date();
    let arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    let cval = (arr = document.cookie.match(reg)) ? encodeURIComponent(arr[2]) : null;
    exp.setTime(exp.getTime() - 1);
    if (cval !== null)
      document.cookie = name + "=" + cval + ";expires=" + exp.toUTCString();
  },
  /**
   * 在数字左边补零
   * @param number 数字
   * @param length 补零后的字符串总长度
   * @returns {string} 补零后的字符串
   */
  padLeft: function (number, length) {
    var string = number.toString();

    while (string.length < length) {
      string = '0' + string;
    }

    return string;
  },
  /**
   * 本地时间转UTC时间
   * @param localTime 本地时间,格式为（YYYY-MM-DD hh:mm:ss / YYYY-MM-DD）
   * @param localTimezone. e.g 北京为8，巴基斯坦为5，美国东岸为-5. 默认值为null，取客户端时区
   * @returns {string} 格式化后的时间字符串
   */
  LocalTimeToUTCTime: function (localTime, localTimezone) {
    localTimezone = localTimezone === undefined ? null : localTimezone;

    //判断是否日期格式
    var temp = new Date(localTime);
    if (temp == 'Invalid Date') {
      return new Error('Invalid Date');
    }

    var date = temp;  //设定参考时间，以本地为准
    var timeDesignated;
    if (localTime.toString().indexOf(':') > 0) { // 检查时候包含时分秒
      if (localTimezone === null) {
        timeDesignated = date;
      } else {
        timeDesignated = new Date(date.getTime() - localTimezone * 3600000 - date.getTimezoneOffset() * 60000).toUTCString();
        timeDesignated = new Date(timeDesignated);
      }

      var year = timeDesignated.getUTCFullYear();
      var month = timeDesignated.getUTCMonth() + 1;
      var day = timeDesignated.getUTCDate();
      var hour = timeDesignated.getUTCHours();
      var min = timeDesignated.getUTCMinutes();
      var sec = timeDesignated.getUTCSeconds();

      var timeFormatStr = this.padLeft(hour, 2) + ":" + this.padLeft(min, 2) + ":" + this.padLeft(sec, 2);
      var dateFormatStr = year + "-" + this.padLeft(month, 2) + "-" + this.padLeft(day, 2) + " " + timeFormatStr;



      return dateFormatStr;
    } else {
      //只有年月日就返回传入日期
      return localTime;
    }
  },
  /**
   * 格式化日期
   * @param createdAt 数据库储存格式 例(2016-01-01 12:01:01)
   * @param isFullFormat 是否显示完整时间，默认显示。完整为(2016-01-01 12:01:01)，不完整(2016-01-01)
   * @returns {string} 格式化后的时间字符串
   */
  formatDate: function (createdAt, isFullFormat) {
    isFullFormat = isFullFormat === undefined ? true : isFullFormat;
    var date = new Date(createdAt);
    var mon = date.getMonth() + 1;
    var day = date.getDate();
    var hour = date.getHours();
    var minutes = date.getMinutes();
    var seconds = date.getSeconds();
    var timeFormatStr = this.padLeft(hour, 2) + ":" + this.padLeft(minutes, 2) + ":" + this.padLeft(seconds, 2);
    var dateFormatStr = date.getFullYear() + "-" + this.padLeft(mon, 2) + "-" + this.padLeft(day, 2) + " " + (isFullFormat ? timeFormatStr : '');

    return dateFormatStr;
  },

  /**
   * UTC时间转本地时间
   * @param UTCTime UTC时间,格式为（YYYY-MM-DD hh:mm:ss / YYYY-MM-DD）
   * @param localTimezone. e.g 北京为8，巴基斯坦为5，美国东岸为-5. 默认值为null，取客户端时区
   * @returns {string} 格式化后的时间字符串
   */
  UTCTimeToLocalTime: function (UTCTime, localTimezone) {
    localTimezone = localTimezone === undefined ? null : localTimezone;

    //判断是否日期格式
    var temp = new Date(UTCTime);
    if (temp == 'Invalid Date') {
      return new Error('Invalid Date');
    }

    var re = new RegExp('[a-zA-Z]');
    var date;
    if(re){
      date = new Date(UTCTime + '+0000');  //设定参考时间，以本地为准
    } else {
      date = new Date(UTCTime + 'Z');  //设定参考时间，以本地为准
    }

    var timeDesignated;
    if (UTCTime.indexOf(':') > 0) { // 检查时候包含时分秒
      if (localTimezone === null) {
        timeDesignated = date;
      } else {
        // 取得 UTC time
        var utc = date.getTime() + (date.getTimezoneOffset() * 60000);

        // 目标时区的时间
        timeDesignated = new Date(utc + (3600000 * localTimezone));
      }
      return this.formatDate(timeDesignated);
    } else {
      //只有年月日就返回传入日期
      return UTCTime;
    }
  },
};



// WEBPACK FOOTER //
// ./src/assets/js/utils.js